import Viewer from "viewerjs";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    console.log("image-viewer connected")
    const images = this.element.getElementsByTagName('img');
    const imgArray = Array.from(images)
    // 为每个图片添加点击事件监听器
    imgArray.forEach((image) => {
      let startX;
      image.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });
      image.addEventListener("touchend", (e) => {
        const endX = e.changedTouches[0].clientX;
        const diff = Math.abs(endX - startX);
        // 如果水平滑动距离小于10px,则认为是点击事件
        if (diff < 10) {
          this.openViewer(e);
        }
      });
      // 桌面端仍然保留点击事件
      image.addEventListener("click", (e) => {
        if (e.pointerType !== 'touch') {
          this.openViewer(e);
        }
      });
    });
  }

  openViewer = (event) => {
    console.log("openViewer")
    const clickedImage = event.currentTarget;
    console.log("clickedImage", this.element, clickedImage)
    // 初始化 Viewer.js
    const toolbar = {
      // 放大
      // zoomIn: 1,
      // // 缩小
      // zoomOut: 1,
      // // 原始大小
      // oneToOne: 1,
      // // 重置
      // reset: 1,
      // // 上一页
      // prev: 1,
      // // 全屏幻灯片
      // play: {
      //   show: 1,
      //   size: "large",
      // },
      // // 下一页
      // next: 1,
      // // 向左旋转90
      // rotateLeft: 1,
      // // 向右旋转90
      // rotateRight: 1,
      // // 水平镜像翻转
      // flipHorizontal: 1,
      // // 垂直镜像翻转
      // flipVertical: 1,
    }
    const viewer = new Viewer(this.element, {
      toolbar
    });
    viewer.view(clickedImage)
  }
}
